/*  Actions  */
import { setSessionInfo } from 'actions/index';

/*  NPM  */
import { connect } from 'react-redux';

/*  Component  */
import JSX from '../Login';

const mapDispatchToProps = (dispatch) => ({
    setSessionInfo: (sessionInfo) => dispatch(setSessionInfo(sessionInfo))
});

export default connect(null, mapDispatchToProps)(JSX);
